import { MAIN_INDEX } from '@helpers/algolia/constants';
import productHitAdapter from '@helpers/algolia/product-hit-adapter';
import getAlgoliaClientDefault from '@services/algolia/getAlgoliaClientDefault';
// Esta função roda tanto no servidor (SSR) quanto no browser (chamada direta por
// componentes/hooks client-side) — usa clientLogger (sem dependências Node) para não
// quebrar o bundle do client, já que o logger de servidor (winston) não pode ser
// importado por um módulo isomórfico como este.
import { clientLogger } from '@services/logger/clientLogger';
import { TProduct } from 'types/product';
/* eslint-disable default-param-last */
import getProductsFromAlgoliaByFilter from './getProductsFromAlgoliaByFilter';

export default async function getProductsFromAlgolia(
  ids: string[],
  searchType = 'getObjects',
  distinct?: boolean
): Promise<TProduct[]> {
  if (searchType === 'getObjects') {
    const algoliaClient = getAlgoliaClientDefault();
    const searchIndex = algoliaClient.initIndex(MAIN_INDEX);

    try {
      const response = await searchIndex.getObjects(ids);
      return response.results
        .map(product => productHitAdapter(product))
        .filter(product => product !== null && product.validation.isValid);
    } catch (error) {
      clientLogger.serviceRequestFailed('Failed to fetch products from Algolia', {
        service: 'algolia',
        action: 'get_products_from_algolia',
        context: { ids, reason: error.message, stack: error.stack },
      });
      return [];
    }
  }

  const algoliaProductsList = await getProductsFromAlgoliaByFilter({
    facetFilters: [],
    filters: ids.map(id => `objectID:'${id}'`).join(' OR '),
    searchOptions: {
      hitsPerPage: ids.length,
      analyticsTags: ['getProductsFromAlgolia'],
      distinct,
    },
    index: MAIN_INDEX,
  });

  return algoliaProductsList.length ? algoliaProductsList : [];
}
